// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    -webkit-user-select: none;
    user-select: none;
}

.modal-backdrop {
    position: fixed;
    width: 100%;
    height: 100vh;
    background-color: rgba(7, 15, 24, 0.7);
}

.modal-panel {
    background-color: var(--muted-grey-color);
    border: 1px solid rgba(93, 189, 232, 0.2);
    width: 16rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
}

.modal-container .close {
    font-size: 1.5rem;
    text-align: end;
    margin-top: -0.5rem;
}

.modal-container .close:hover {
    color: var(--light-grey-color);
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,MAAM;IACN,OAAO;IACP,yBAAyB;IAEzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,yCAAyC;IACzC,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,eAAe;AACnB","sourcesContent":[".modal-container {\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\n.modal-backdrop {\n    position: fixed;\n    width: 100%;\n    height: 100vh;\n    background-color: rgba(7, 15, 24, 0.7);\n}\n\n.modal-panel {\n    background-color: var(--muted-grey-color);\n    border: 1px solid rgba(93, 189, 232, 0.2);\n    width: 16rem;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n}\n\n.modal-container .close {\n    font-size: 1.5rem;\n    text-align: end;\n    margin-top: -0.5rem;\n}\n\n.modal-container .close:hover {\n    color: var(--light-grey-color);\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
